import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class JwtCustonService {
    constructor() {}

    get Token(): string | null {
        if (sessionStorage.getItem('TokenJwt')) return sessionStorage.getItem('TokenJwt');

        return null;
    }

    logout() {
        sessionStorage.removeItem('TokenJwt');
    }
}
